import React from "react";
import { ArrowRight } from "lucide-react";

/**
 * Primary Calendly CTA with a quiet "20 minute chat · no obligation" micro-label.
 * Centered or left-aligned via the `align` prop.
 */
export const BookChatCTA = ({
  calendlyUrl,
  align = "start",
  label = "Book a 20 minute chat",
  testId = "book-chat-cta",
}) => {
  const wrap = align === "center" ? "items-center text-center" : "items-start text-left";
  return (
    <div className={`inline-flex flex-col gap-2 ${wrap}`}>
      <a
        href={calendlyUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="sc-btn-primary self-start"
        data-testid={testId}
      >
        {label}
        <ArrowRight size={16} />
      </a>
      <span
        className="text-[11px] uppercase tracking-[0.22em] text-muteink/80 font-body self-start"
        data-testid={`${testId}-microlabel`}
      >
        20 minute chat · no obligation
      </span>
    </div>
  );
};

export default BookChatCTA;
